import { configureStore } from '@reduxjs/toolkit'

import { createWrapper } from 'next-redux-wrapper'
import reducers from './reducers'

const masterReducer = (state: any, action: any) => {
    return reducers(state, action)
}

export const configureAppStore = (initialState = {}) => {
    const store = configureStore({
        reducer: masterReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    // Ignore these field paths in all actions
                    ignoredActionPaths: [
                        'payload.headers',
                        'payload.config',
                        'payload.request'
                    ]
                    // ignoredPaths: ['visaRequirements.dateOfArrival']
                }
            }),
        preloadedState: initialState,
        devTools: true
    })

    return store
}

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>

export const store = configureAppStore()
export const wrapper = createWrapper(configureAppStore)
